import ShopSection from './ShopSection'

export default ShopSection
